module.exports = __webpack_public_path__ + "static/product-collection-header-d40c6d0e9cdf2ae27ed7818548cadc1b.svg";